import Locale from '@/modules/user/Enum/Locale';
import Enum from '/@/modules/core/app/helpers/Enum';

export class LocaleQueryParam extends Enum {
  static ENGLISH: string = 'en';
  static FRENCH_QUEBEC: string = 'fr-qc';
  static FRENCH_CANADA: string = 'fr-CA';

  static isFrenchType(lang: string | null): boolean {
    if (!lang) {
      return false;
    }

    return lang === this.FRENCH_QUEBEC || lang === this.FRENCH_CANADA;
  }

  static getLocale(locale?: string): string | undefined {
    if (locale && this.isFrenchType(locale)) {
      return Locale.FRENCH.key;
    }

    return locale;
  }
}
